import * as React from 'react'
import Price, * as Prices from 'theme/atoms/Price'
import B2cSwitch from 'theme/atoms/B2cSwitch'
import styled from 'styled-components'
import theme from 'theme'
import * as gt from 'utils/productShapeTypes'

export type Props = {
  'data-cy-state': string
  variant: {
    prices: gt.ProductPriceDefinition
    priceRules: gt.ProductPriceRulesDefinition
    unit: gt.ProductUnitDefinition
  }
}

export default function ProductPrice(props: Props) {
  const { prices, priceRules, unit } = props.variant
  return (
    <Wrapper className="price" data-cy-state={props['data-cy-state']}>
      {prices.productCheapestPiecePriceNet &&
        prices.productMostexpensivePiecePriceNet && (
          <div data-cy-state="has-strikeprice" className="labels">
            {Prices.PriceHasStrikePrice({ prices, priceRules }, 1) && (
              <span className="strike" data-cy-state="has-strikeprice">
                <Prices.PriceStrike prices={prices} logic="piece" />
              </span>
            )}
            <span
              className={
                Prices.PriceHasStrikePrice({ prices, priceRules }, 1)
                  ? 'strike-reduced'
                  : ''
              }
            >
              <Price prices={prices} logic="piece" />
            </span>
          </div>
        )}

      <div className="details">
        {unit.purchaseUnit > 1 && (
          <div data-cy-state="has-purchaseUnit-greater-one">
            <span>
              <Price prices={prices} logic="pack" scalePrice={priceRules} />
              {' / '}
              {unit.purchaseUnit} {unit.unitName}
            </span>
          </div>
        )}
        {prices.referencePriceNetString && (
          <span data-cy-state="has-baseprice">
            <B2cSwitch.B2B>{prices.referencePriceNetString}</B2cSwitch.B2B>
            <B2cSwitch.B2C>{prices.referencePriceGrossString}</B2cSwitch.B2C>
          </span>
        )}
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  ${theme.ty('r-l', '700', 'r-2xl')};

  > .labels {
    display: flex;
    align-items: center;

    > .reduced {
      margin-left: ${theme.spacing('xxs')};
    }
  }
  .croatiaCurrency {
    width: 68px;
    height: 18px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 18px;
    color: #625d52;
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  & .strike {
    color: ${theme.colors.shade.b3};
    text-decoration: line-through;
    margin-right: ${theme.spacing('xs')};
    ${theme.ty('r-s', null, 'r-l')};
  }
  & .strike-reduced {
    color: ${theme.colors.accent.red};
  }
  & .details {
    color: ${theme.colors.shade.b3};

    ${theme.ty('r-s', null, 'r-base')};
  }
`
